<p>
    <button (click)="throwNullpointer()">throw Nullpointer</button><br>
    <button (click)="throwApiError()">throw ApiError</button><br>
</p>
